import axios from "../config"

class UserAccountService{
    axios;
    constructor(){
        this.axios = axios;
    }
    
      getUi(userType) {
        let url = `/ui`;
        return this.axios.get(url,{params:{
          userType
        }}).then(request => request.data);
      }
      updateUi(uiAccept) {
        let url = `/ui`;
        return this.axios.put(url,uiAccept).then(request => request.data);
      }
      getUiByUserId() {
        let url = `/ui/userId`;
        return this.axios.get(url).then(request => request.data);
      }
      getUserAccountsProfile(userType,page) {
        let url = `/useraccounts/profile`
        return axios.get(url,{
            params:{
                userType,page
            }
        }).then(request => request.data);
      }
      
    changePassword(currentPassword, newPassword) {
      let url = `userAccounts/changepassword`
      return this.axios.get(url,
        {
          params: {
            currentPassword,
            newPassword
          }
        }).then(request => request.data);
    }
    
    onesignalAccount(){
      let url = `/onesignalAccount`
      return axios.get(url).then(request => request.data);
    }

    getUserList(userType,userName,userId) {
      let url = `/userAccount`
      return axios.get(url,{
          params:{
            userType,userName,userId
          }
      }).then(request => request.data);
    }

    addUserList(user) {
      let url = `/userAccount`;
      return this.axios.post(url, user).then(request => request.data);
  }

  getUserDetailList(userAccountId) {
    let url = `/userAccount/${userAccountId}`
    return axios.get(url).then(request => request.data);
  }
  updateUserList(userAccount) {
    let url = `/userAccount/${userAccount.userAccountId}`;
    return this.axios.put(url, userAccount).then(request => request.data);
}
deleteUserList(userAccount) {
  let url = `/userAccount/${userAccount.userAccountId}`;
  return this.axios.delete(url).then(request => request.data);
}
getUserAccountDtoBySearch(search) {
  let url = `/userAccounts/tensearch`
  return axios.get(url,{
      params:{
        search
      }
  }).then(request => request.data);
}
 
getUserListForDD() {
  let url = `userAccounts/userList`;
  return this.axios.get(url).then(request => request.data);
}
getUserAccountsSale(userType) {
  let url = `/userAccounts/sale`
  return axios.get(url,{
      params:{
          userType
      }
  }).then(request => request.data);
}
getUserListFinance() {
  let url = `/userAccount/finance`
  return axios.get(url).then(request => request.data);
}
getUserAccountTownship(userType,tsId) {
  let url = `/useraccounts/ts`
  return axios.get(url,{
      params:{
          userType,tsId
      }
  }).then(request => request.data);
}
getUserAccountsCity(userType,cityId) {
  let url = `/useraccounts/city`
  return axios.get(url,{
      params:{
          userType,cityId
      }
  }).then(request => request.data);
}
getDebitUser(userAccountId) {
  let url = `/useraccount/${userAccountId}/balance`
  return axios.get(url).then(request => request.data);
}
}

const service = new UserAccountService();
export default service;